import { HoldType } from '@api';
import {
  SearchTableInput,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
  TouringDataTable,
  useManageTableContext,
} from '@common';
import { useHoldsColumns } from './hooks';

type HoldsTablePropsType = {
  dataTestId: string;
  holds: HoldType[];
  isFetching: boolean;
  title: string;
  disabledColumns?: string[];
};

export const HoldsTable: React.FC<HoldsTablePropsType> = ({
  dataTestId,
  holds,
  isFetching,
  title,
  disabledColumns,
}) => {
  const { columns } = useHoldsColumns({ disabledColumns });

  const {
    tableArguments: {
      pagination,
      search: { searchValue, setSearchValue },
    },
  } = useManageTableContext();

  return (
    <TouringCard data-testid={dataTestId}>
      <TouringCardHeader>
        <TouringCardTitle>{title}</TouringCardTitle>
        <TouringCardActions>
          <SearchTableInput
            search={searchValue ?? ''}
            setSearchValue={setSearchValue}
          />
        </TouringCardActions>
      </TouringCardHeader>
      <TouringCardSection>
        <TouringDataTable<HoldType>
          records={holds}
          columns={columns}
          fetching={isFetching}
          withTableBorder={false}
          {...pagination}
        />
      </TouringCardSection>
    </TouringCard>
  );
};
